import { NotificationService } from './../../../../../core/src/lib/notifications/notifications.service';
import { Component, OnInit } from '@angular/core';

import { Store, select } from '@ngrx/store';
import { LorpDto } from '@cradua/data';
import { Observable } from 'rxjs/internal/Observable';
import { routeAnimations, ROUTE_ANIMATIONS_ELEMENTS } from 'libs/core/src/lib/animations';
import { GatewayFacade } from 'libs/gateway/src/lib/states/+gateway/gateway.facades';

@Component({
  selector: 'cradua-lorp-container',
  templateUrl: './lorp-container.component.html',
  styleUrls: ['./lorp-container.component.scss']
})
export class LorpContainerComponent implements OnInit {

  routeAnimationsElements = ROUTE_ANIMATIONS_ELEMENTS;
  lorps$: Observable<LorpDto[]>;
  loading: boolean;
  isLoadingLorp$: Observable<boolean>;
  constructor(
    private gatwayFacade: GatewayFacade,
    private notificationService: NotificationService
  ) {}

  ngOnInit() {
    this.isLoadingLorp$ = this.gatwayFacade.isLoadingGateway("Lorp");
    this.lorps$ = this.gatwayFacade.loadGateway("Lorp");
    this.lorps$.subscribe(data => {
      console.log("data: cont.",data);

    })
  }

/**
 this method dispatches array of ids to the effects,
 which handle the sending of data asynchronously
  */

  onDeleteLorp(deletedValue: any) {
    this.gatwayFacade.remove("Lorp", deletedValue);
    // this.store.dispatch(LorpStoreActions.removeLorp({ids: deletedValue}));
    this.notificationService.success('Deleted Successfully');
  }


// this method control both the create and update

  onSubmitLorp(formValue: any) {
    console.log("form value: ", formValue);
    formValue.Lorps = formValue.Lorps.reverse();
    event.preventDefault();
    const pullData = formValue.Lorps;
    //const newPullData = formValue.Lorpes;

// declare two empty array to hold update and create data
  let allUpdates = [] ;
  let addAllLorp = [];


// loop through the form data to check for update and create

  for(let i = 0; i < pullData.length; i++) {
    if(pullData[i].id !== null) {
      allUpdates.push(pullData[i]);
    } else {
      delete pullData[i].id;
      addAllLorp.push(pullData[i]);
    }
  }

// check if the addAllLorp array is not empty, then dispatch the data to the store
   if(addAllLorp.length !== 0) {
    this.gatwayFacade.add('Lorp', addAllLorp);
    // this.store.dispatch(LorpStoreActions.addLorp({newLorp: addAllLorp}));

   }

// dispatch update data to the store
this.gatwayFacade.update('Lorp', allUpdates, ['id']);
    // this.store.dispatch(LorpStoreActions.updateLorp({updateLorp: allUpdates}));
    this.notificationService.success('Saved Successfully');

  }

}



